

















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import contactsRepository from '@/services/contactsRepository';
import cPopup from '@/components/default/Popup.vue';
import DataSource from 'devextreme/data/data_source';
import dxCustomStore from 'devextreme/data/custom_store';
import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxItem, DxLabel } from 'devextreme-vue/form';

@Component({
  components: {
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxItem,
    DxLabel,
    cPopup,
  },
})
export default class LinkContactDialog extends Vue {
  public show: boolean = false;
  public formData: IContactRelation = {
    contactA: '',
    contactB: '',
    reference: '',
  };
  private saving: boolean = false;

  private isValid() {
    if (!this.formData.contactB || !this.formData.contactA || this.formData.contactB === '' || this.formData.contactA === '') {
      return false;
    }
    return true;
  }

  private async save() {
    if (this.isValid()) {
      try {
        this.saving = true;
        await contactsRepository.postRelation(this.formData);
        this.show = false;
        notificationService.saved();
        this.$emit('updated');
      } catch (err) {
        notificationService.showAxiosError(err);
      } finally {
        this.saving = false;
      }
    } else {
      notificationService.invalidForm();
    }
  }

  get contactsOptions() {
    const self = this;
    return {
      dataSource: new DataSource({
        store: new dxCustomStore({
          load: async (loadOptions) => {
            const result = (await contactsRepository.lookup(loadOptions)).data.data.filter((c: IBasicContact) => !c.type.toLowerCase().includes('employee'));
            return {
              data: result,
            };
          },
          byKey: async (val: any) => {
            return await contactsRepository.getSingle(val);
          },
        }),
        paginate: true,
      }),
      displayExpr: 'displayName',
      valueExpr: 'id',
      searchEnabled: true,
      itemTemplate: (e: IBasicContact) => {
        let icon = 'fa-user';
        switch (e.type) {
          case 'Subcontractor':
            icon = 'fa-hard-hat';
            break;
          case 'Company':
            icon = 'fa-building';
            break;
        }
        return `<i class="fas ${icon}"></i> ${e.displayName}`;
      },
      fieldTemplate: (e: IBasicContact) => {
        if (e) {
          let icon = 'fa-user';
          switch (e.type) {
            case 'Subcontractor':
              icon = 'fa-hard-hat';
              break;
            case 'Company':
              icon = 'fa-building';
              break;
          }
          return `<div><i class="fas ${icon}"></i> ${e.displayName}</div>`;
        }
        return '<div></div>';
      },
    };
  }
}
